var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"unlockable-slider border is-flex is-flex-1 slider-bar"},[(_vm.value > 0)?_c('div',{staticClass:"unlockable-slider-inner border slider-bar",style:(_setup.widthStyle)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }